import React from 'react';
import './App.css';
import { Alert, Button } from 'reactstrap';
import Nav from './components/Nav/Nav';
import ToastPanel from './components/Toasts/ToastPanel';
import * as utilities from './utilities';
import CompanyContext from './auth/CompanyContext';
import AuthenticationButton from './components/AuthenticationButton/AuthenticationButton';

export default class App extends React.Component {
  static contextType = CompanyContext;

  constructor(props) {

    super(props);
    this.user = 0;
    this.available_dates = [];
    this.favorites = {};
    this.state = {
      available_dates: this.available_dates,
      loading: true,
      us_states: [
        { state: '', abbr: '' },
        { state: 'Alabama', abbr: 'AL' },
        { state: 'Alaska', abbr: 'AK' },
        { state: 'America Samoa', abbr: 'AS' },
        { state: 'Arizona', abbr: 'AZ' },
        { state: 'Arkansas', abbr: 'AR' },
        { state: 'California', abbr: 'CA' },
        { state: 'Colorado', abbr: 'CO' },
        { state: 'Connecticut', abbr: 'CT' },
        { state: 'Delaware', abbr: 'DE' },
        { state: 'District of Columbia', abbr: 'DC' },
        { state: 'Federated State of Micronesia', abbr: 'FM' },
        { state: 'Florida', abbr: 'FL' },
        { state: 'Georgia', abbr: 'GA' },
        { state: 'Guam', abbr: 'GU' },
        { state: 'Hawaii', abbr: 'HI' },
        { state: 'Idaho', abbr: 'ID' },
        { state: 'Illinois', abbr: 'IL' },
        { state: 'Indiana', abbr: 'IN' },
        { state: 'Iowa', abbr: 'IA' },
        { state: 'Kansas', abbr: 'KS' },
        { state: 'Kentucky', abbr: 'KY' },
        { state: 'Louisiana', abbr: 'LA' },
        { state: 'Maine', abbr: 'ME' },
        { state: 'Marshall Islands', abbr: 'MH' },
        { state: 'Maryland', abbr: 'MD' },
        { state: 'Massachusetts', abbr: 'MA' },
        { state: 'Michigan', abbr: 'MI' },
        { state: 'Minnesota', abbr: 'MN' },
        { state: 'Mississippi', abbr: 'MS' },
        { state: 'Missouri', abbr: 'MO' },
        { state: 'Montana', abbr: 'MT' },
        { state: 'Nebraska', abbr: 'NE' },
        { state: 'Nevada', abbr: 'NV' },
        { state: 'New Hampshire', abbr: 'NH' },
        { state: 'New Jersey', abbr: 'NJ' },
        { state: 'New Mexico', abbr: 'NM' },
        { state: 'New York', abbr: 'NY' },
        { state: 'North Carolina', abbr: 'NC' },
        { state: 'North Dakota', abbr: 'ND' },
        { state: 'Northern Mariana Islands', abbr: 'MP' },
        { state: 'Ohio', abbr: 'OH' },
        { state: 'Oklahoma', abbr: 'OK' },
        { state: 'Oregon', abbr: 'OR' },
        { state: 'Palau', abbr: 'PW' },
        { state: 'Pennsylvania', abbr: 'PA' },
        { state: 'Puerto Rico', abbr: 'PR' },
        { state: 'Rhode Island', abbr: 'RI' },
        { state: 'South Carolina', abbr: 'SC' },
        { state: 'South Dakota', abbr: 'SD' },
        { state: 'Tennessee', abbr: 'TN' },
        { state: 'Texas', abbr: 'TX' },
        { state: 'Utah', abbr: 'UT' },
        { state: 'Vermont', abbr: 'VT' },
        { state: 'Virgin Islands', abbr: 'VI' },
        { state: 'Virginia', abbr: 'VA' },
        { state: 'Washington', abbr: 'WA' },
        { state: 'West Virginia', abbr: 'WV' },
        { state: 'Wisconsin', abbr: 'WI' },
        { state: 'Wyoming', abbr: 'WY' },
      ],
      user: 0,
      userData: {},
      userPermissions: [],
      loadingUsers: false,
      loadError: ''
    };
  }

  componentDidMount() {
    this.getTables();
    this.getUsers();
  }

  updateUser = (auth0) => {
    this.user = auth0;
    this.loadFavorites()
  }

  getUsers = (sub = this.props.auth0, json_request = {}) => {
    // sub = process.env.REACT_APP_IMPERSONATE_AUTH0; // impersonate
    // console.log('App.js/getUsers()')
    // if (this.state.loadingUsers || sub == null) return;
    this.setState({
      loadingUsers: true
    }, () => {
      fetch('/api/users/' + sub, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.props.clientToken,
          'X-Database': this.context.company
        }
      })
        .then(results => {
          if (!results.ok) throw new Error(`Unable to load user setup (${results.status})`);
          return results.json();
        })
        .then(results => {
          if (results.data.length === 1) {
            this.setState({
              user: sub,
              userData: results.data[0],
              userPermissions: results.data[0].Permissions,
              loadingUsers: false,
              loadError: ''
            }, () => this.updateUser(sub)
            );
          } else {
            this.setState({
              loadingUsers: false,
              loadError: 'Unable to find your user setup for this company.'
            });
          }
        })
        .catch(err => {
          this.setState({
            loadingUsers: false,
            loadError: err.message || 'Unable to load your user setup.'
          });
        });
    })
  }

  loadFavorites = (callback) => {
    fetch('/api/favorites/' + this.user, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
      })
      .then(results => {
        if (!results.ok) throw new Error(`Unable to load company tables (${results.status})`);
        return results.json();
      })
      .then(results => {
        if ("data" in results) {
          this.favorites = results.data;
          if (callback !== undefined && typeof (callback) === 'function') callback(this.favorites);
        }
      });
  }

  getFavorites = () => {
    return this.favorites;
  }

  addFavorite = (type, favorite, callback) => {
    fetch('/api/favorites/', {
      method: 'POST',
      body: JSON.stringify({
        auth0: this.user,
        type: type,
        favorite: favorite
      }),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        if (results.success) {
          this.loadFavorites(callback);
        }
      });
  }

  removeFavorite = (type, favorite, callback) => {
    fetch('/api/favorites/' + this.user + '/' + type + '/' + favorite, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        if (results.success) {
          this.loadFavorites(callback);
        }
      });
  }

  getTables = () => {
    fetch('/api/tables/', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        let tableArray = []
        if ("data" in results) {
          results.data.forEach(row => {
            const tableName = row.table.trim().slice(-6); // just in case
            tableArray.push({
              date_key: tableName,
              date_string: `${tableName.substring(0,2)}/20${tableName.substring(4, 6)}`
            });
          })
          this.setState(
            {
              available_dates: tableArray,
              loading: false
            }
          )
        } else {
          this.setState({
            loading: false,
            loadError: 'Unable to load company data.'
          })
        }
      })
      .catch(err => {
        this.setState({
          loading: false,
          loadError: err.message || 'Unable to load company data.'
        });
      });
  }

  render() {
    const isLoading = this.state.loading;
    const loadError = this.state.loadError;
    const readyAvailableDates = this.state.available_dates.length > 0;
    const readyUserData = Object.keys(this.state.userData).length > 0;
    const readyUserPermissions = this.state.userPermissions.length > 0;
    const readyUser = this.state.user !== 0;

    return (
      <div className="App">
        {loadError ?
          <Alert color="danger" className="m-4 text-left">
            <h4>Unable to load application setup</h4>
            <p>{loadError}</p>
            <p className="mb-3">Your account may not be fully configured for this company yet.</p>
            {this.props.resetCompany && (
              <Button color="secondary" className="mr-2" onClick={this.props.resetCompany}>
                Change Company
              </Button>
            )}
            <AuthenticationButton />
          </Alert>
          :
          isLoading || !readyUserData || !readyUserPermissions || !readyUser ?
          <h2>Loading...</h2>
          :
          <>{readyAvailableDates ?
            <Nav
              clientToken={this.props.clientToken}
              idToken={this.props.idToken} 
              {...this.state}
              loadFavorites={this.loadFavorites}
              updateUser={this.updateUser}
              addFavorite={this.addFavorite}
              removeFavorite={this.removeFavorite}
              getFavorites={this.getFavorites}
              refreshUser={this.getUsers}
              resetCompany={this.props.resetCompany}
              companies={this.props.companies}
              database={this.props.company}
              getToken={this.props.getToken}
            />
            :
            <Alert color="danger">
              Unable to load data. Please try again later.
            </Alert>
          }</>
        }
        <div className="toastPanel align-bottom">
          <ToastPanel addCallback={utilities.addCallback} log={utilities.log} info={utilities.info} />
        </div>
      </div>
    );
  }
}
